import request from "config/api";
import { server_url } from "../constants/types";
import { showAppApiAlert } from "./appActions";

export const fetchAppConfig = () => async (dispatch) => {
  try {
    request({
      method: "GET",
      url: `${server_url}/appconfig`,
    }).then((data) => {
      dispatch({ type: "FETCH_CONFIG_SUCCESS", payload: data.data[0] });
    });
  } catch (error) {
    console.error("Failed to fetch app config", error);
  }
};

export const updateAppConfig = (config) => async (dispatch) => {
  try {
    request({
      method: "PUT",
      url: `${server_url}/appconfig/${config.configId}`,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(config),
    })
      .then((data) => {
        console.log("Updated >>", data);
        dispatch({ type: "UPDATE_CONFIG", payload: config });
        dispatch(
          showAppApiAlert({
            showAlert: true,
            type: "error",
            message: "Configuration Settings updated Successfully!",
          })
        );
      })
      .catch((error) => {
        console.error("Error updating app config", error);
        dispatch(
          showAppApiAlert({
            showAlert: true,
            type: "error",
            message: `Error in saving settings, please try later. Error Message: ${error?.response?.data}`,
          })
        );
      });
  } catch (error) {
    console.error("Failed to update app config", error);
  }
};

